export default {
  setLoader(state, payload) {
    state.showLoader = payload;
  },
  toggleMenuOpened(state, { type }) {
    state.isMenuOpened[type] = !state.isMenuOpened[type];
  },
  toggleActiveMenuItem(state, { type, item = '' }) {
    state.activeMenuItem[type] = item;
  },
  toggleMobileSearchOpened(state) {
    state.isMobileSearchOpened = !state.isMobileSearchOpened;
  },
  setHeaderPrefix(state, payload) {
    state.headerPrefix = payload;
  },
  scrollDownMobileHide(state, payload) {
    state.isScrollDownMobileHide = payload;
  },
  initialMobileHideSearch(state, payload) {
    state.isInitialMobileHideSearch = payload;
  },
  setCategoryMenuData(state, payload) {
    state.categoryMenuData = payload;
  },
  setMobileCategoryMenuData(state, payload) {
    state.mobileCategoryMenuData = payload;
  },
  setAutocompleteCategoryMenuData(state, payload) {
    state.autocompleteCategoryMenuData = payload;
  },
  setUserMenuData(state, { data }) {
    state.userMenuData = data;
  },
  toggleShowPageDarkLayer(state, value) {
    state.showPageDarkLayer = value;
  },
  setAgeInformationPopupShow(state, value) {
    state.ageInformationPopup.show = value;
  },
  setAgeInformationPopupAddToCartInfo(state, value) {
    state.ageInformationPopup.addToCartInfo = value;
  },
};
